// extracted by mini-css-extract-plugin
export default {"itemWrapper":"BottomNavigationItem_itemWrapper__Mk9TK","disabled":"BottomNavigationItem_disabled__aKHV4"};